import { bidStateFlags, bidStateFlagsEnum } from "helpers/enums/bidStateFlags";

const actionFlags = [
    bidStateFlagsEnum.WaybillTitleSignRequired,
    bidStateFlagsEnum.WaybillChangeTitleRequired,
    bidStateFlagsEnum.WaybillExternalRevisionsSignRequired,
    bidStateFlagsEnum.WaybillDeliveryCompletionRequired,
];

/** Read every independent action reason, including combinations and unrelated bid flags. */
export const getBidWaybillActionFlags = (intStateFlags: number) =>
    bidStateFlags
        .filter(({ value, intValue }) => actionFlags.includes(value) && (intStateFlags & intValue) === intValue)
        .map(({ value }) => value);

/** Filter all bids on the server before pagination, independently of title status filters. */
export const buildBidWaybillActionFilter = (required: string) => {
    const filter = { or: actionFlags.map((flag) => ({ stateFlags: { has: flag } })) };
    if (required === "true") {
        return filter;
    }
    return required === "false" ? { not: [filter] } : {};
};
